import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogSurface,
    DialogBody,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    makeStyles,
    tokens,
} from '@fluentui/react-components';
import { iconMap } from '../../theme/icons';
import SelectionBox from './../components/blocks/SelectionBox';

import handle1 from '../../assets/img/handle_type/1.jpg';
import handle2 from '../../assets/img/handle_type/2.jpg';
import handle3 from '../../assets/img/handle_type/3.jpg';
import handle4 from '../../assets/img/handle_type/4.jpg';
import handle5 from '../../assets/img/handle_type/5.jpg';
import handle6 from '../../assets/img/handle_type/6.jpg';
import handle7 from '../../assets/img/handle_type/7.jpg';

const CloseIcon = iconMap.close;

const handleOptions = [
    { value: 0, label: 'Be rankenėlių', image: handle1 },
    { value: 1, label: 'Be rankenėlių (užlaida 2.5cm)', image: handle2 },
    { value: 2, label: 'Be rankenėlių (sumažintos 2.5cm)', image: handle3 },
    { value: 3, label: 'Rankenėlės', image: handle4 },
    { value: 4, label: 'Įleidžiamos', image: handle5 },
    { value: 5, label: 'Nuo paspaudimo', image: handle6 },
    { value: 6, label: 'Frezuotos', image: handle7 },
];

const useStyles = makeStyles({
    surface: { maxWidth: '56.25rem' },
    // CSS grid + repeat(auto-fit,...) su fiksuoto pločio SelectionBox (type=column,
    // justifySelf:start) palikdavo tuščius grid langelius kaip pilno pločio "tarpus",
    // kai stulpelių daugiau nei realių elementų (žr. /admin/bugs "Ta pati grid
    // problema, nenaudojam grid" — bendra taisyklė visiems dialogams). flex+wrap+gap
    // vietoj grid — kiekvienas elementas užima tik savo turinio plotį.
    grid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
    actions: { gap: tokens.spacingHorizontalS },
    actionBtn: { flex: 1 },
});

const HandlesDialog = ({ open, onClose, onHandleSelect, currentHandle }) => {
    const [tempHandle, setTempHandle] = useState(currentHandle || 0);
    const s = useStyles();

    useEffect(() => {
        if (open) setTempHandle(currentHandle || 0);
    }, [open, currentHandle]);

    const handleConfirm = () => {
        onHandleSelect(tempHandle);
        onClose();
    };

    return (
        <Dialog open={open} onOpenChange={(e, data) => { if (!data.open) onClose(); }}>
            <DialogSurface id="dialog-handles" className={s.surface}>
                <DialogBody>
                    <DialogTitle
                        action={<Button appearance="subtle" icon={<CloseIcon />} aria-label="Uždaryti" onClick={onClose} />}
                    >
                        Pasirinkite rankenėlės tipą
                    </DialogTitle>
                    <DialogContent>
                        <div className={s.grid}>
                            {handleOptions.map((option) => (
                                <SelectionBox
                                    key={option.value}
                                    image={option.image}
                                    title={option.label}
                                    selected={tempHandle === option.value}
                                    onClick={() => setTempHandle(option.value)}
                                />
                            ))}
                        </div>
                    </DialogContent>
                    <DialogActions className={s.actions}>
                        <Button size="large" appearance="outline" onClick={onClose} className={s.actionBtn}>
                            Atšaukti
                        </Button>
                        <Button size="large" appearance="primary" onClick={handleConfirm} className={s.actionBtn}>
                            Pasirinkti
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default HandlesDialog;
